{
  "version": 1,
  "asset_id": "9d98fc90-219c-4990-b4f5-f8e29e561b28",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/9d98fc90-219c-4990-b4f5-f8e29e561b28/stamped-concrete-project.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/9d98fc90-219c-4990-b4f5-f8e29e561b28/stamped-concrete-project.mp4",
  "original_filename": "stamped-concrete-project.mp4",
  "size": 1643072,
  "content_type": "video/mp4",
  "created_at": "2026-09-11T22:26:27Z"
}
